import { useState, useEffect, useCallback } from 'react'

export const useDataManagement = (fetchFunction, deleteFunction = null) => {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [searchQuery, setSearchQuery] = useState('')
	const [error, setError] = useState(null)

	// Fetch data from API
	const fetchData = useCallback(async () => {
		try {
			setLoading(true)
			setError(null)
			const result = await fetchFunction()
			setData(result)
		} catch (err) {
			console.error('Error fetching data:', err)
			setError(err.message || 'Failed to fetch data')
		} finally {
			setLoading(false)
		}
	}, [fetchFunction])

	// Handle delete
	const handleDelete = useCallback(
		async (id) => {
			if (!deleteFunction) return

			const choice = window.confirm('Are you sure you want to delete this item?')
			if (choice) {
				try {
					await deleteFunction(id)
					await fetchData() // Refresh data
				} catch (err) {
					console.error('Error deleting item:', err)
					setError(err.message || 'Failed to delete item')
				}
			}
		},
		[deleteFunction, fetchData]
	)

	useEffect(() => {
		fetchData()
	}, [fetchData])

	return {
		data,
		loading,
		searchQuery,
		setSearchQuery,
		error,
		handleDelete,
		fetchData
	}
}
